// Does the header's inline navigation actually fit in the bar?
//
// The bar used to answer this with a Tailwind breakpoint (`hidden 2xl:flex`),
// i.e. by asserting that the navigation fits from 1536px up. Measured, the
// signed-in admin bar needs 1507px — a margin of 29px, under 2%. A margin that
// thin does not survive a different font renderer: the same labels are a few
// pixels wider on Windows than in a headless Linux Chromium, and the last entry
// silently lost its final letters. Nothing reported it, because the nav scrolled
// with its scrollbar hidden.
//
// A breakpoint cannot know what it needs to know: font metrics, the display
// language, the length of the signed-in user's first name, whether they are an
// admin. So the bar measures instead, and this is the decision it makes —
// isolated from the DOM so it can be tested on numbers alone.

// Sub-pixel rounding must not make the bar flicker between the two layouts at
// one exact width, and a decision this close to the edge is not one worth
// winning: below this margin the navigation moves to the menu.
export const FIT_MARGIN = 8;

/**
 * @param {object} m
 * @param {number} m.available  width the bar has for its children (padding out)
 * @param {number} m.brand      the logo's width — never shrinks
 * @param {number} m.nav        the navigation's natural width, unclipped
 * @param {number} m.right      account, language and menu controls — never shrink
 * @param {number} m.gaps       the flex gaps between those three blocks
 * @returns {boolean}
 */
export const navFitsInBar = ({ available, brand, nav, right, gaps = 0 }) => {
  const needed = brand + nav + right + gaps + FIT_MARGIN;
  return needed <= available;
};
